<div class="endorsement-item-container">
  <div class="endorsement-image" [responsiveBackgroundImage]="image">
    <div class="endorsement-gradient"></div>
  </div>
  <div class="endorsement-label">
    <div class="endorsement-name">{{ endorsement.name }}</div>
    <div class="endorsement-title">{{ endorsement.title }}</div>
  </div>
</div>